import { AnimatedComponent } from 'sane-ui'
// import { SplitText } from 'gsap/all'

class Copy extends AnimatedComponent {
  // constructor ($el, args) {
  //   args.offset = '95%'
  //   super($el, args)
  // }

  buildTimelineIn () {
    const $parts = this.$el.find('p, dd, dt, li, hr, .form-group, [data-copy-part]')

    this.timelineIn
      .set(this.$el, { autoAlpha: 1 })

    $parts.each(
      (i, part) => {
        const $part = $(part)
        if ($part.is('hr')) {
          this.timelineIn
            .from(
              $part,
              { duration: 0.3, opacity: 0, ease: 'none' },
              i * 0.075
            )
            .from(
              $part,
              { duration: 0.3, scaleX: 0, ease: 'power2.out' },
              i * 0.075
            )
        } else {
          this.timelineIn
            .from(
              $part,
              { duration: 0.6, opacity: 0, ease: 'none' },
              i * 0.075
            )
            .from(
              $part,
              { duration: 0.6, y: '15px', ease: 'power2.out' },
              i * 0.075
            )
        }
      }
    )
  }
}

export default Copy



// WEBPACK FOOTER //
// ./scripts/components/animation/Copy.js